import { MAX_QUANTITY_LIMIT } from '@grandvisionhq/fun-products';

const getMaxSelectableQuantity = ({ availableQuantity , maxOrderableQuantity , allowBackOrder  })=>{
    if (!allowBackOrder) {
        if (maxOrderableQuantity && availableQuantity) {
            return maxOrderableQuantity > availableQuantity ? availableQuantity : maxOrderableQuantity;
        }
        if (availableQuantity !== undefined) {
            return availableQuantity;
        }
    }
    if (maxOrderableQuantity) {
        return maxOrderableQuantity;
    }
    return MAX_QUANTITY_LIMIT;
};

export { getMaxSelectableQuantity };
//# sourceMappingURL=get-max-selectable-quantity.js.map
